import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import onboarding01 from '@/assets/images/onboarding/01.png';
import onboarding02 from '@/assets/images/onboarding/02.png';
import onboarding03 from '@/assets/images/onboarding/03.png';
import { useI18n } from '@/contexts/I18nContext';

export const OnboardingCarousel = () => {
  const { t } = useI18n();
  
  const slides = [
    {
      image: onboarding01,
      title: t('onboarding.carousel.slide_1.title'),
      subtitle: t('onboarding.carousel.slide_1.subtitle')
    },
    {
      image: onboarding02,
      title: t('onboarding.carousel.slide_2.title'),
      subtitle: t('onboarding.carousel.slide_2.subtitle')
    },
    {
      image: onboarding03,
      title: t('onboarding.carousel.slide_3.title'),
      subtitle: t('onboarding.carousel.slide_3.subtitle')
    }
  ];
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);
    onSelect();
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <div className="w-full max-w-md mx-auto mb-6 sm:px-6 px-2 box-border pt-24 overflow-x-hidden">
      <div className="relative w-full flex flex-col items-center">
        {/* Imagem sobreposta ao topo do card */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-24 z-20 w-38 h-40 flex flex-col justify-start items-center pointer-events-none">
          <img src={slides[selectedIndex].image} alt={slides[selectedIndex].title} className="object-contain w-full h-full" />
        </div>
        {/* Card com padding-top menor */}
        <div className="embla rounded-3xl px-2 pb-8 pt-0 shadow-2xl backdrop-blur-md w-full relative"
        style={{
          outline: '2px solid rgba(255,255,255,0.18)',
          outlineOffset: '-2px',
          background: 'linear-gradient(180deg, rgba(255,255,255,0.30) 0%, rgba(255,255,255,0) 100%)'
        }}
      >
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container flex">
            {slides.map((slide, idx) => (
              <div className="embla__slide relative flex flex-col items-center justify-center w-full min-w-full" key={idx}>
                {/* Content with padding-top to avoid overlap */}
                <div className="flex flex-col items-center pt-20">
                  <h2 className="text-white text-xl font-bold font-sans text-center mb-2 drop-shadow-md">{slide.title}</h2>
                  <p className="text-white/90 text-sm text-center max-w-[80%] mx-auto mb-2 drop-shadow-sm break-words">{slide.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Dots */}
        <div className="flex justify-center gap-2 mt-2">
          {slides.map((_, idx) => (
            <button
              key={idx}
              className={`w-1.5 h-1.5 rounded-full transition-all duration-200 ${selectedIndex === idx ? 'bg-white' : 'bg-white/40'}`}
              onClick={() => emblaApi && emblaApi.scrollTo(idx)}
              aria-label={t('onboarding.carousel.go_to_slide', { slide: idx + 1 })}
            />
          ))}
          </div>
        </div>
      </div>
    </div>
  );
}; 